import { resetIndexedDB, saveImageToDB } from "../../../utils/indexedDB";

export const saveCanvas = async ({
  petType,
  setNotSelectedKey,
  toast,
  cartItems,
  canvasRef,
  uploadedImageIds,
  petName,
  selectedFrame,
  navigate,
  setStaticBg,
  image,
  redirectTo,
}) => {
  if (!petType) {
    setNotSelectedKey(prev => prev + 1);
    toast.warn('Please Select a Pet Type');
    return;
  }

  setNotSelectedKey(0);
  setStaticBg(null);

  setTimeout(async () => {
    const canvas = canvasRef.current;
    canvas.toBlob(async (blob) => {
      if (!blob) return;

      const imageId = Date.now().toString();
      localStorage.setItem("resultImageId", imageId);
      resetIndexedDB("resultImages", cartItems);
      resetIndexedDB("onProductImages", cartItems);
      await saveImageToDB('resultImages', imageId, blob, null, null, uploadedImageIds);
      window.dispatchEvent(new CustomEvent("resultImageReady"));

      if (petName !== '') {
        localStorage.setItem("petName", petName);
      } else {
        localStorage.removeItem("petName");
      }

      if (image) {
        const metadata = {
          x: parseFloat(image.x.toFixed(1)),
          y: parseFloat(image.y.toFixed(1)),
          scale: image.scale,
          width: image.width,
          height: image.height,
          maxScale: image.maxScale,
          rotation: image.rotation,
        };
        localStorage.setItem("imageMetadata", JSON.stringify(metadata));
      } else {
        localStorage.removeItem("imageMetadata");
      }

      localStorage.setItem("label_template", selectedFrame.name)
      localStorage.setItem("petType", petType);
      window.dispatchEvent(new CustomEvent("petTypeReady"));

      if(redirectTo){
        navigate(redirectTo);
      }
    }, "image/png");
  }, 50);
};
